import type { LevelId } from "./state/GameState";
import { Tex } from "./ui/textures";
import { Palette } from "./ui/palette";

export interface LevelMeta {
  id: LevelId;
  index: number; // 0-based order
  title: string;
  subtitle: string;
  mapKey: string; // Phaser tilemap cache key (loaded in PreloadScene)
  mapPath: string; // file under public/
  sceneKey: string;
  playerTex: string;
  accent: number;
}

export const LEVELS: LevelMeta[] = [
  {
    id: "dan",
    index: 0,
    title: "Dan",
    subtitle: "Grind / Accumulation — climb & collect",
    mapKey: "map-dan",
    mapPath: "assets/maps/level1-dan.tmj",
    sceneKey: "Level1Dan",
    playerTex: Tex.playerDan,
    accent: Palette.dan,
  },
  {
    id: "lucas",
    index: 1,
    title: "Lukas",
    subtitle: "Spatial Puzzle — keys, doors, the vault",
    mapKey: "map-lucas",
    mapPath: "assets/maps/level2-lucas.tmj",
    sceneKey: "Level2Lucas",
    playerTex: Tex.playerLucas,
    accent: Palette.lucas,
  },
  {
    id: "andrew",
    index: 2,
    title: "Andrew",
    subtitle: "Speed / Reflex — auto-run & squash bugs",
    mapKey: "map-andrew",
    mapPath: "assets/maps/level3-andrew.tmj",
    sceneKey: "Level3Andrew",
    playerTex: Tex.playerAndrew,
    accent: Palette.andrew,
  },
];

export function levelById(id: LevelId): LevelMeta {
  return LEVELS.find((l) => l.id === id)!;
}
